export const blackListedDomains = [
    "10minutemail.com",
    "anonaddy.com",
    "anonaddy.me",
    "burnermail.io",
    "cool.fr.nf",
    "courriel.fr.nf",
    "dispostable.com",
    "emailondeck.com",
    "fakeinbox.com",
    "getairmail.com",
    "guerrillamail.com",
    "maildrop.cc",
    "mailinator.com",
    "mailnesia.com",
    "mailnull.com",
    "mintemail.com",
    "moakt.com",
    "mytemp.email",
    "sharklasers.com",
    "spamgourmet.com",
    "tempmail.email",
    "temp-mail.org",
    "throwawaymail.com",
    "trashmail.com",
    "yopmail.com",
    "yopmail.fr",
    "tempmail.com",
    "getnada.com",
    "chefalicious.com",
    "ptct.net",
    "belgianairways.com",
    "goeschman.com",
    "dcpa.net",
    "thetechnext.net",
    "getnada.com",
    "chefalicious.com",
    "ptct.net",
    "belgianairways.com",
    "goeschman.com",
    "dcpa.net",
    "asciibinder.net",
    "azuretechtalk.net",
    "logsmarter.net",
    "polkaroad.net",
    "cyclelove.cc",
    "punkproof.com",
    "dreamclarify.org",
    "mongrec.com",
    "cyluna.com",
    "ozkadem.edu.pl",
    "tmst.com.tr",
    "gufum.com",
    "astimei.com"
]
